import { Turbo } from "@hotwired/turbo-rails"

// Replace Turbo's native confirm() (data-turbo-confirm) with a daisyUI
// modal, matching the client-side cancel-trip dialog instead of the
// browser default.
Turbo.setConfirmMethod((message) => {
  return new Promise((resolve) => {
    const dialog = document.createElement("dialog")
    dialog.className = "modal"
    dialog.innerHTML = `
      <div class="modal-box max-w-sm">
        <p class="py-2 text-sm"></p>
        <div class="modal-action">
          <button type="button" class="btn btn-ghost" data-role="cancel">Cancel</button>
          <button type="button" class="btn btn-error" data-role="confirm">Confirm</button>
        </div>
      </div>`
    dialog.querySelector("p").textContent = message
    document.body.appendChild(dialog)

    const done = (result) => {
      dialog.close()
      dialog.remove()
      resolve(result)
    }
    dialog.querySelector('[data-role="cancel"]').addEventListener("click", () => done(false))
    dialog.querySelector('[data-role="confirm"]').addEventListener("click", () => done(true))
    dialog.addEventListener("cancel", (event) => { event.preventDefault(); done(false) }) // Esc
    dialog.addEventListener("click", (event) => { if (event.target === dialog) done(false) }) // backdrop

    dialog.showModal()
    dialog.querySelector('[data-role="confirm"]').focus()
  })
})
